module.exports = __webpack_public_path__ + "static/media/alianza-white-logo.eb42db70.png";


//////////////////
// WEBPACK FOOTER
// ./src/lib/whiteLabel/alianza-white-logo.png
// module id = 64
// module chunks = 0